import { useMemo } from 'react'

import { useSelector } from 'react-redux'

import type { Collection, MenuCollectionsState } from 'reducers/menu-collections/menuCollections'

export const useCollections = (): Collection[] => {
  const collectionsMap = useSelector(
    (state: MenuCollectionsState) => state.menuV3Collections?.collections,
  )

  // useMemo prevents components from infinite renders, Object.values always returns new array
  return useMemo(() => Object.values(collectionsMap || {}), [collectionsMap])
}
